import React, {useState} from 'react';
import CloseIcon from '@material-ui/icons/Close';
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import IconButton from "@material-ui/core/IconButton";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";


const InvalidStatusDialog = ({trackData}) => {
    const [errOpen, setErrOpen] = useState(false);
    let invalid = !trackData || !trackData.Properties || `${trackData.Properties.WeighterValidity}` !== "1";
    if (invalid) return "";
    return <>
        <CloseIcon color={"error"} onClick={() => setErrOpen(true)} style={{cursor:"pointer"}}/>
        <Dialog open={errOpen} onClose={() => setErrOpen(false)} maxWidth="sm" fullWidth>
            <Toolbar>
                <Typography variant="title" color="inherit" className="flex">
                    Информация о проезде
                </Typography>
                <IconButton color="inherit" onClick={() => setErrOpen(false)}>
                    <CloseIcon className="blue"/>
                </IconButton>
            </Toolbar>
            <DialogContent>
                {trackData.Properties.InvalidReason || "Причина невалидности отсутсвует"}
            </DialogContent>
        </Dialog>
    </>;
};

export default InvalidStatusDialog;
